import authSlice from "../redux/auth/slice";
import accountsSlice from "../redux/accounts/slice";
import addressSlice from "../redux/address/slice";
import staffsSlice from "../redux/staffs/slice";
import notificationSlice from "../redux/notification/slice";
import serviceSlice from "../redux/service/slice";
import companiesSlice from "../redux/companies/slice";
import dashboardSlice from "../redux/dashboard/slice";
import productsSlice from "../redux/product/slice";
import { configureStore } from "@reduxjs/toolkit";

const rootReducer = {
  authData: authSlice,
  accountsData: accountsSlice,
  addressData: addressSlice,
  staffsData: staffsSlice,
  notificationData: notificationSlice,
  serviceData: serviceSlice,
  companiesData: companiesSlice,
  dashboardData: dashboardSlice,
  productsData: productsSlice,
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
